import { useCurrentUser } from '@rover/rsdk/src/modules/Data/Core/CurrentUser';

const useIsBHUser = (): boolean => {
  const { data } = useCurrentUser();

  if (!data) return false;
  return ('currentUser' in data && data.currentUser.isBrightHorizonsUser) ?? false;
};

export default useIsBHUser;
